import React from "react";
import { useApp } from "@/state/AppContext";
import { resolveImage } from "@/lib/media";

/** UAT P2x — the storefront's photo gallery. `StorefrontOut.gallery` (a list of image URLs) was
 * modelled and served but no section ever rendered it. Gated on DATA like `plans`: hidden entirely
 * when the business has no photos, never a placeholder grid. */
export function GalleryBlock({ business }) {
  const { t } = useApp();
  const photos = (business.gallery || []).filter(Boolean);
  if (photos.length === 0) return null;

  return (
    <div data-testid="storefront-gallery">
      <h3 className="font-heading text-lg font-semibold">{t("storefront.gallery.title")}</h3>
      <div className="mt-3.5 grid grid-cols-2 gap-3 sm:grid-cols-3">
        {photos.map((url, i) => (
          <img
            key={`${url}-${i}`}
            src={resolveImage(url)}
            alt={t("storefront.gallery.photoAlt", { name: business.name, n: i + 1 })}
            loading="lazy"
            decoding="async"
            width={400}
            height={300}
            className="aspect-[4/3] w-full rounded-xl border border-border object-cover"
            data-testid={`storefront-gallery-photo-${i}`}
          />
        ))}
      </div>
    </div>
  );
}
